export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const LOGOUT = 'LOGOUT'
export const USER_ROLE = 'USER_ROLE'
export const USER_SOCIETE_ID = 'USER_SOCIETE_ID'
export const USER_ID = 'USER_ID'
export const SET_FIRSTNAME = 'SET_FIRSTNAME'
export const SET_NAME = 'SET_NAME'
export const SET_SOCIETENOM = 'SET_SOCIETENOM'
export const SOCIETE_LISTES = 'SOCIETE_LISTES'



// WEBPACK FOOTER //
// ./src/store/modules/login/mutation_types.js